var NonPublicHour = function (src) {
    var self = this;
    src = src || {};
    self.NPHoursId = src.NPHoursId || 0;
    self.StudentId = src.StudentId || 0;
    self.CalendarYear = src.CalendarYear || 0; 
    self.FirstName = src.FirstName || '';
    self.MiddleInitial = src.MiddleInitial || '';
    self.LastName = src.LastName || '';
    self.ForestName = src.ForestName || '';
    self.IsPLC = src.IsPLC || false; 
    self.DispatchDate = src.DispatchDate || '';
    self.ReturnedDate = src.ReturnedDate || ''; 
    self.EstimatedHours = src.EstimatedHours || 0;
    self.Hours = src.Hours || 0; 
    self.Active = src.Active || 1;
    self.Deleted = src.Deleted || 0;
    self.Creator = src.Creator || '';
    self.LastModifiedBy = src.LastModifiedBy || '';
    self.CreatedDate = src.CreatedDate || new Date();
    self.CreatedDateString = src.CreatedDateString || '';
    self.CreatedBy = src.CreatedBy || '';
    self.LastUpdated = src.LastUpdated || new Date();
    self.LastUpdatedString = src.LastUpdatedString || '';
    self.LastUpdatedBy = src.LastUpdatedBy || '';
    self.UpdatingApp = src.UpdatingApp || '';
    self.FullName = src.LastName + ", " + src.FirstName;
    return self;
};
NonPublicHour.prototype.fullName = function () {
    return (this.LastName || '') + ', ' + (this.FirstName || '') + this.MiddleInitial + ' ';
};
angular.module('jcsfApp').value('NonPublicHour', NonPublicHour);